export default "__VITE_ASSET__22b188da__"